/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const ComponentDebug = (props) => {

    const component = props?.component;
    const field = props?.field;
    const name = field?.name;

    return (
        <div
            style={{
                border: "1px solid red", padding: "24px", minHeight: "120px",minWidth: "100%",
                display: "flex", flexDirection: "column",
                justifyContent: "center", alignItems: "center"
            }}
        >
            <div>{component.type}</div>
            <div>{name}</div>
        </div>
    );
}

ComponentDebug.displayName = "ComponentDebug";
export { ComponentDebug };
